import { render, staticRenderFns } from "./emailUpdateApproval.vue?vue&type=template&id=e7363604&scoped=true&"
import script from "./emailUpdateApproval.vue?vue&type=script&lang=ts&"
export * from "./emailUpdateApproval.vue?vue&type=script&lang=ts&"
import style0 from "./emailUpdateApproval.vue?vue&type=style&index=0&id=e7363604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7363604",
  null
  
)

export default component.exports